var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDaimond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "#FFC107",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M26.65 23.05a.75.75 0 0 1 .6-.3h13.5a.75.75 0 0 1 .6.3l4.465 5.96a.79.79 0 0 1 .015.966L34.6 44.95a.75.75 0 0 1-1.2 0l-11.25-15a.75.75 0 0 1 0-.9zm17.079 5.678-2.71-3.617-1.163 3.621zm-5.45.006 1.442-4.484H28.28l1.444 4.493zm-8.074 1.508L34 42.05l3.798-11.815zm-2.057-1.498L26.98 25.11l-2.729 3.638zm-3.9 1.504 7.67 10.226-3.288-10.23zm11.834 10.226 7.684-10.246-4.392.005z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaimond);
export default __webpack_public_path__ + "static/media/daimond.63eddda5230b75e1c2202fb03f2f6801.svg";
export { ForwardRef as ReactComponent };